import { createContext, useContext, useState, ReactNode } from 'react';

interface DesignerState {
  roomType: string;
  selectedStyle: string;
  customIdeas: string;
  uploadedImage: string | null;
}

interface DesignerContextType {
  state: DesignerState;
  setState: (state: Partial<DesignerState>) => void;
  resetState: () => void;
}

const initialState: DesignerState = {
  roomType: '',
  selectedStyle: '',
  customIdeas: '',
  uploadedImage: null,
};

const DesignerContext = createContext<DesignerContextType | undefined>(undefined);

export const DesignerProvider = ({ children }: { children: ReactNode }) => {
  const [state, setStateInternal] = useState<DesignerState>(initialState);

  const setState = (newState: Partial<DesignerState>) => {
    setStateInternal(prev => ({ ...prev, ...newState }));
  };

  const resetState = () => {
    setStateInternal(initialState);
  };

  return (
    <DesignerContext.Provider value={{ state, setState, resetState }}>
      {children}
    </DesignerContext.Provider>
  );
};

export const useDesigner = () => {
  const context = useContext(DesignerContext);
  if (!context) {
    throw new Error('useDesigner must be used within DesignerProvider');
  }
  return context;
};
